import { HvlDateConverter, HvlMapConverter } from '@hvlng/framework-bff/util';
import { HvlBaseModel, MaxLength } from '@hvlng/framework-bff/core';
import { JsonProperty, JsonObject } from 'json2typescript';
import { Required, EmptyControl } from '@hvlng/framework-bff/core';

import { CodeTextDiscriminatorModel, HrCommonConstants, TextModel } from 'humanresources-common-shared';

import { TimeConstrainedBaseModel } from 'humanresources-common-shared';

@JsonObject('KovanHrOrganizationDefinitionModel')
export class OrganizationDefinitionModel extends HvlBaseModel {
    @Required()
    @JsonProperty('beginDate', HvlDateConverter, true)
    beginDate: Date = null;

    @Required()
    @JsonProperty('endDate', HvlDateConverter, true)
    endDate: Date = null;

    @Required()
    @JsonProperty('count', Number, true)
    count: number = null;
    @EmptyControl()
    @JsonProperty('perObjectId', Number, true)
    perObjectId: number = null;

    @EmptyControl()
    @JsonProperty('perObjectDefinitionId', Number, true)
    perObjectDefinitionId: number = null;

    @EmptyControl()
    @JsonProperty('perObjectDefinitionText', String, true)
    perObjectDefinitionText: string = null;

    @EmptyControl()
    @JsonProperty('perObjectDefinitionUnitCode', String, true)
    perObjectDefinitionUnitCode: string = null;
    @EmptyControl()
    @JsonProperty('perObjectDefinitionUuid', String, true)
    perObjectDefinitionUuid: string = null;

    @EmptyControl()
    @JsonProperty('perObjectDefinitionPId', Number, true)
    perObjectDefinitionPId: number = null;

    @EmptyControl()
    @JsonProperty('positionId', Number, true)
    positionId: number = null;

    @EmptyControl()
    @JsonProperty('perObjectDefinitionPText', String, true)
    perObjectDefinitionPText: string = null;

    @EmptyControl()
    @JsonProperty('managerPerPeopleId', Number, true)
    managerPerPeopleId: number = null;
    @Required()
    @JsonProperty('objectStatusId', Number, true)
    objectStatusId: number = null;

    @EmptyControl()
    @JsonProperty('objectStatus', CodeTextDiscriminatorModel, true)
    objectStatus: CodeTextDiscriminatorModel = null;

    @EmptyControl()
    @JsonProperty('objectStatusText', String, true)
    objectStatusText: string = null;

    @EmptyControl()
    @JsonProperty('objectStatusCode', String, true)
    objectStatusCode: string = null;
    @EmptyControl()
    @JsonProperty('name', String, true)
    name: string = null;
    @EmptyControl()
    @JsonProperty('surname', String, true)
    surname: string = null;

    @EmptyControl()
    @JsonProperty('objectNumber', String, true)
    objectNumber: string = null;

    @Required()
    @EmptyControl()
    @JsonProperty('employeeCount', Number, true)
    employeeCount: number = 0;

    @EmptyControl()
    @JsonProperty('employeeTotalCount', Number, true)
    employeeTotalCount: number = 0;
    @EmptyControl()
    @JsonProperty('versionIdName', String, true)
    versionIdName: string = null;
    @Required()
    @JsonProperty('companyId', Number, true)
    companyId: number = null;
    @EmptyControl()
    @JsonProperty('companyName', String, true)
    companyName: string = null;

    @EmptyControl()
    @JsonProperty('detailMap', HvlMapConverter, true)
    detailMap: Map<string, TextModel> = new Map<string, TextModel>();

    @MaxLength(50)
    @Required()
    @JsonProperty('shortText', String, true)
    shortText: string = null;

    @MaxLength(250)
    @Required()
    @JsonProperty('longText', String, true)
    longText: string = null;
    @EmptyControl()
    @JsonProperty('active', Boolean, true)
    active: boolean = null;
    @MaxLength(50)
    @JsonProperty('objectCode', String, true)
    objectCode: string = null;
    @Required()
    @JsonProperty('genCountryId', Number, true)
    genCountryId: number = null;
    @EmptyControl()
    @JsonProperty('versionId', Number, true)
    versionId: number = null;

    @EmptyControl()
    @JsonProperty('estDate', HvlDateConverter, true)
    estDate: Date = null;
    @EmptyControl()
    @JsonProperty('secret', Boolean, true)
    secret: boolean = null;

    @EmptyControl()
    @JsonProperty('centralOrganization', Boolean, true)
    centralOrganization: boolean = null;

    @EmptyControl()
    @JsonProperty('separation', Boolean, true)
    separation: boolean = null;

    @EmptyControl()
    @JsonProperty('connectedOrganizationId', Number, true)
    connectedOrganizationId: number = null;

    @EmptyControl()
    @JsonProperty('authorizationLevelId', Number, true)
    authorizationLevelId: number = null;
    @EmptyControl()
    @JsonProperty('organizationTypeId', Number, true)
    organizationTypeId: number = null;
    @EmptyControl()
    @JsonProperty('locationId', Number, true)
    locationId: number = null;

    @EmptyControl()
    @JsonProperty('subProvinceText', String, true)
    subProvinceText: string = null;

    @EmptyControl()
    @JsonProperty('provinceText', String, true)
    provinceText: string = null;

    @EmptyControl()
    @JsonProperty('managerNameSurname', String, true)
    managerNameSurname: string = null;
}
